export const makeInfo = (pathInfo) => {
  const getRvrSysNm = () => {
    const name = pathInfo.RiverSysNm || ''
    if (name.endsWith('その他')) {
      return ''
    }
    if (name.endsWith('川')) {
      return name + '水系'
    }
    return name
  }
  const getRvrNm = () => {
    const name = pathInfo.RiverNm || ''
    if (name.endsWith('その他')) {
      return ''
    }
    return name
  }
  const rvrSysNm = getRvrSysNm()
  const rvrNm = getRvrNm()
  if (pathInfo.RiverSysNmRoma === 'others') {
    return (rvrNm ? ` ${rvrNm}` : '') + (pathInfo.Address ? ` (${pathInfo.Address})` : '')
  }
  return (rvrSysNm ? rvrSysNm + (rvrNm ? ` ${rvrNm}` : '') : rvrNm) + (pathInfo.Address ? ` (${pathInfo.Address})` : '')
}

export const setRank = (value, list) => {
  let rank = 0
  if (!value || !list) {
    return rank
  }
  if (list.length === 0) {
    return rank
  }
  list.forEach((item) => {
    if (item.value <= value) {
      rank = item.rank
    }
  })
  return rank
}

export const makeTrueId = (id) => {
  if (id.includes('_')) {
    return 'cctv_' + id
  }
  return id
}

const simpleParseCsv = (csvStr) => {
  const [header, ...lines] = csvStr.trim().split('\n')
  const keys = header.split(',')
  return lines.map((line) => {
    const values = line.split(',')
    return Object.fromEntries(keys.map((k, i) => [k, values[i]]))
  })
}

export const makeGeoJson = (csv, waterLevel, currentPointId) => {
  const records = simpleParseCsv(csv)
  const rankMap = new Map(
    (waterLevel || []).map((item) => [item.id, Number(item.rank)])
  )
  const rankZeroFeatures = []
  const rankNoneZeroFeatures = []
  const createFeature = (lon, lat, row, type, rank) => ({
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [lon, lat]
    },
    properties: {
      name: row.Name,
      path: row.ID,
      rvr_sys_roma: row.RiverSysNmRoma,
      type,
      rank
    }
  })

  for (const row of records) {
    const lon = parseFloat(row.Lon)
    const lat = parseFloat(row.Lat)
    const typeInt = parseInt(row.Type, 10)
    const rank = rankMap.get(row.ID) || 0

    if (typeInt === 1 || typeInt === 2) {
      // obs_point
      if (rank > 0) {
        rankNoneZeroFeatures.push(createFeature(lon, lat, row, 'obs', rank))
      } else {
        if (currentPointId && row.ID === currentPointId) {
          rankNoneZeroFeatures.push(createFeature(lon, lat, row, 'obs', 0))
        }
        rankZeroFeatures.push(createFeature(lon, lat, row, 'obs', 0))
      }
      // typeInt === 2 の場合のみカメラ情報も追加
      if (
        typeInt === 2
        && row.CameraID
        && row.CameraLat
        && row.CameraLon
        && !isNaN(parseFloat(row.CameraLat))
        && !isNaN(parseFloat(row.CameraLon))
      ) {
        rankZeroFeatures.push(
          createFeature(
            parseFloat(row.CameraLon),
            parseFloat(row.CameraLat),
            row,
            'cam',
            0
          )
        )
        if (currentPointId && row.ID === currentPointId) {
          rankNoneZeroFeatures.push(createFeature(parseFloat(row.CameraLon), parseFloat(row.CameraLat), row, 'cam', 0))
        }
      }
    } else if (typeInt === 3) {
      // camera
      if (currentPointId && row.ID === currentPointId) {
        rankNoneZeroFeatures.push(createFeature(lon, lat, row, 'cam', 0))
      }
      rankZeroFeatures.push(createFeature(lon, lat, row, 'cam', 0))
    }
  }
  const clusteredGeoJson = {
    type: 'FeatureCollection',
    features: rankZeroFeatures
  }
  const unclusteredGeoJson = {
    type: 'FeatureCollection',
    features: rankNoneZeroFeatures
  }
  return { clusteredGeoJson, unclusteredGeoJson }
}

export const cubicBezier = (p1x, p1y, p2x, p2y) => {
  // https://github.com/gre/bezier-easing/blob/master/src/index.js より簡易実装
  function A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1
  }
  function B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1
  }
  function C(aA1) {
    return 3.0 * aA1
  }
  function calcBezier(t, aA1, aA2) {
    return ((A(aA1, aA2) * t + B(aA1, aA2)) * t + C(aA1)) * t
  }
  function getSlope(t, aA1, aA2) {
    return 3.0 * A(aA1, aA2) * t * t + 2.0 * B(aA1, aA2) * t + C(aA1)
  }
  function getTforX(aX) {
    let aGuessT = aX
    for (let i = 0; i < 4; ++i) {
      const currentSlope = getSlope(aGuessT, p1x, p2x)
      if (currentSlope === 0.0) return aGuessT
      const currentX = calcBezier(aGuessT, p1x, p2x) - aX
      aGuessT -= currentX / currentSlope
    }
    return aGuessT
  }
  return function (x) {
    return calcBezier(getTforX(x), p1y, p2y)
  }
}
